import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';

const Event: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Event');

    function handleLink() {
        window.open('https://www.furusatotokyofes.com/', '_blank');

        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: '',
            page_name: 'furusato-tokyo-support-festival',

            __btn_id1: 'event-img-btn',
            __btn_id2: 'event-img-btn',
            __btn_type: 'common',
        });
    }
    return (
        <div className={styles.Event + ' GtmModuleData-section'} data-section-id="event">
            <div className="lp-layout">
                <div className="title">{t('title')}</div>

                <div className="event-img GtmModuleData-btn-common event-img-btn" data-btn-id="event-img-btn" onClick={() => handleLink()}>
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1765503931366/20251212-094226.webp" />
                </div>
                <div className="host">{t('host')}</div>
                <div className="sponsor">{t('sponsor')}</div>
            </div>
        </div>
    );
};

export default Event;
